import { useEffect, useState } from "react"

import MyPageModal from "../../../components/mypage/MyPageModal"

import LoginForm from "../../login/components/LoginForm"
import { SignupForm } from "../../signup/components/SignupForm"
import { SignupComplete } from "../../signup/components/SignupComplete"
import type { EstimateDraft } from "../../signup/types/SignUpEstimate"
import type useAuthModal from "../hooks/useAuthModal"

type Props = ReturnType<typeof useAuthModal>["authModalProps"] & {
  estimateDraft?: EstimateDraft
  url?: URL | null
  coupon?: string
}
export type ViewMode = "login" | "signup" | "signup-complete"

export const AuthModal = ({ isOpen, onMount, onLogin, shouldRedirect, close, estimateDraft, url, coupon }: Props) => {
  const [viewMode, setViewMode] = useState<ViewMode>("login")
  const [registeredEmail, setRegisteredEmail] = useState("")

  const switchToSignup = () => setViewMode("signup")
  const handleSignupSuccess = (email: string) => {
    setRegisteredEmail(email)
    setViewMode("signup-complete")
  }
  const handleClose = () => {
    close()
    setViewMode("login")
  }

  useEffect(() => {
    if (isOpen) {
      onMount?.()
    }
  }, [isOpen, onMount])

  return (
    <MyPageModal isOpen={isOpen} onRequestClose={handleClose}>
      <>
        {viewMode === "login" && <LoginForm switchToSignup={switchToSignup} onLogin={onLogin} shouldRedirect={shouldRedirect} />}
        {viewMode === "signup" && (
          <SignupForm onSuccess={handleSignupSuccess} estimateDraft={estimateDraft} url={url ?? null} coupon={coupon} />
        )}
        {viewMode === "signup-complete" && <SignupComplete email={registeredEmail} onClose={handleClose} />}
      </>
    </MyPageModal>
  )
}
